import { createPendoStub, PENDO_STORAGE_PREFIXES } from '~/utils/pendo/stub'
import { reportPendoError } from '~/utils/pendo/track-queue'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { user, loggedIn } = useUserSession()

  if (!config.public.pendoApiKey) {
    console.warn('Nuxt Plugin: Pendo API key is not set. Pendo will not be loaded.')
    return
  }

  if (!isPendoEnabled(config.public.pendoEnabled)) {
    console.warn('Nuxt Plugin: Pendo is disabled. Skipping Pendo initialization.')
    return
  }

  const env = config.public.env || 'development'

  window.pendo = createPendoStub()

  useAnalyticsScript({
    key: 'pendo',
    src: `https://content.beta.juridika.no/agent/static/${config.public.pendoApiKey}/pendo.js`,
    storagePrefixes: PENDO_STORAGE_PREFIXES,
    enabled: loggedIn,
  })

  let initialized = false

  watch([user, loggedIn], async ([user, loggedIn]) => {
    if (!user || !loggedIn) {
      return
    }

    try {
      const organization = user.activeOrganization
      const hashedEmail = await hashSHA256(user.email ?? '', 'hex')

      const options = {
        visitor: {
          id: `${env}-${hashedEmail}`,
          loggedIn: true,
          role: user.role?.[0] || 'unknown',
          source: user.source || 'unknown',
          hasLicense: !!user.licenses?.length,
          licenseModel: user.licenses?.[0]?.licenseModel || 'unknown',
          isInternal: isInternalEmail(user.email),
        },
        account: {
          id: organization?.number || 'unknown',
          name: organization?.name || 'unknown',
        },
      }

      // Rejects a second initialize, so later calls use identify with updated data.
      if (initialized) {
        window.pendo?.identify?.(options)
      }
      else {
        window.pendo?.initialize?.(options)
        initialized = true
      }
    }
    catch (e) {
      reportPendoError(e)
    }
  }, { immediate: true })
})
